const team = [
  {
    name: 'Andrei Shakh',
    github: 'https://github.com/strawberrystr1',
    photo: 'andrei.jpg',
  },
  {
    name: 'Dmytro Zozuliak',
    github: 'https://github.com/DmytroZozuliak',
    photo: 'dima.jpg',
  },
  {
    name: 'Denis Popov',
    github: 'https://github.com/denis0ff',
    photo: 'denis.jpg',
  },
];

export default team;
